import React, { Component } from 'react';
import { Redirect } from 'react-router-dom/cjs/react-router-dom';

import { UTILITY_USER_ROLE_ANONYMOUS } from 'common/utility/userRoles';

import branch from 'client/core/branch';
import { SCREEN_ID_UTILITY_PROFIT_LOGIN } from 'client/constants/screenIds';
import withScreenId from 'client/helpers/withScreenId';
import withTransitionHook from 'client/helpers/withTransitionHook';
import { getUserLandingPage } from 'client/helpers/allowedUtilityRoles';

import SrBox from 'client/components/SrBox';
import SrFlex from 'client/components/SrFlex';
import SrUtilityPartnerLoginForm from 'client/components/SrUtilityPartnerLoginForm';

@withTransitionHook
@withScreenId(SCREEN_ID_UTILITY_PROFIT_LOGIN)
@branch({
  utilityUser: ['utilityUser'],
})
class UtilityProfitPartnerLoginPage extends Component {
  static getPageMetadata = () => ({
    pageTitle: 'Utility Profit | Login',
  });

  render() {
    const { utilityUser, location } = this.props;

    if (!utilityUser.roles.includes(UTILITY_USER_ROLE_ANONYMOUS)) {
      return <Redirect to={getUserLandingPage({ userRoles: utilityUser.roles })} />;
    }

    return (
      <SrBox className="page-login utility-login">
        <SrBox className="loginContainer">
          <SrFlex flexDirection="column" alignItems="center">
            <SrBox
              width="250px"
              height="40px"
              marginTop="20px"
              backgroundImage="url(/images/utility-profit-logo.svg)"
              backgroundSize="contain"
              backgroundRepeat="no-repeat"
              backgroundPosition="center"
            />
          </SrFlex>
          <SrUtilityPartnerLoginForm location={location} />
        </SrBox>
      </SrBox>
    );
  }
}

UtilityProfitPartnerLoginPage.displayName = 'UtilityProfitPartnerLoginPage';

export default UtilityProfitPartnerLoginPage;
